// Mi espacio › Hoy › Mis objetivos: for each goal, the related open tasks and
// goal actions and the next step, decided in code from the same records
// (Personal Tasks with Goal Ids, Personal Applications with their goal). Nothing
// is copied or stored here.
//
// Next step: the open item with the earliest date (overdue first); without
// dates, the lowest step of a plan made with "De un objetivo a tareas", then a
// high-priority task, then the oldest open task; then an action of the goal.
// A goal with no open item says so ("sin próximo paso"): completing tasks is
// not the result, so the goal stays as it is until Ale changes its status.

const PRIO = { high: 0, normal: 1, low: 2 };

function compareSteps(a, b) {
  const da = a.dueOn || a.plannedOn || '', db = b.dueOn || b.plannedOn || '';
  if (da && db && da !== db) return da.localeCompare(db);
  if (da && !db) return -1;
  if (!da && db) return 1;
  if (a.type !== b.type) return a.type === 'task' ? -1 : 1;
  const pa = a.source?.kind === 'plan' ? a.source.order || 0 : Infinity, pb = b.source?.kind === 'plan' ? b.source.order || 0 : Infinity;
  if (pa !== pb) return pa - pb;
  if ((PRIO[a.priority] ?? 1) !== (PRIO[b.priority] ?? 1)) return (PRIO[a.priority] ?? 1) - (PRIO[b.priority] ?? 1);
  return String(a.createdAt || '').localeCompare(String(b.createdAt || ''));
}

/**
 * goals: the day view's goal summaries; tasks: open tasks (any date); actions: open goal actions.
 * Returns the goals in order (active first, then by target date and title), each with
 * { open: [...items], next, overdue: n }. Items carry `type` ('task' | 'application').
 */
export function goalFocus({ goals = [], tasks = [], actions = [], today = '' }) {
  const order = { active: 0, paused: 1, achieved: 2, dropped: 3 };
  return goals
    .map(g => {
      const open = [
        ...tasks.filter(t => t.status === 'open' && (t.goalIds || []).includes(g.id)).map(t => ({ ...t, type: 'task' })),
        ...actions.filter(a => a.goalId === g.id && ['idea', 'trying'].includes(a.status)).map(a => ({ ...a, type: 'application' })),
      ].filter((x, i, all) => all.findIndex(y => y.id === x.id) === i).sort(compareSteps);
      const overdue = open.filter(x => (x.dueOn || x.plannedOn) && (x.dueOn || x.plannedOn) < today).length;
      return { ...g, open, next: open[0] || null, overdue };
    })
    .sort((a, b) => (order[a.status] ?? 9) - (order[b.status] ?? 9) || String(a.targetOn || '9999').localeCompare(String(b.targetOn || '9999')) || a.title.localeCompare(b.title, 'es'));
}
